import angular from "angular";

angular
    .module('dashboard', []);

export default 'dashboard';


// WEBPACK FOOTER //
// ./resources/assets/modules/dashboard/dashboard.module.js